import TagComponentMapper from "components/Mappers/TagComponentMapper";
import { maxTags } from "helpers/constants/OrganisationConstants";
import { concatStringTagsToArray } from "helpers/GeneralHelpers";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

interface TagInputProps {
  tagList: string[];
  onTagsUpdated: (tags: string[]) => void;
  disabled?: boolean;
  formClass?: string;
}

const TagInput = ({
  tagList,
  onTagsUpdated,
  disabled = false,
  formClass = "",
}: TagInputProps) => {
  const [tagInput, setTagInput] = useState<string>("");
  const [tagArray, setTagArray] = useState<string[]>(tagList);

  useEffect(() => {
    setTagArray(tagList);
  }, [tagList]);

  const handleChangeTagInput = (event: ChangeEvent<HTMLInputElement>) => {
    setTagInput(event.target.value);
  };

  const handleAddTags = (event: FormEvent) => {
    event.preventDefault();
    if (tagInput.length !== 0 && tagArray.length < maxTags) {
      const updatedTags = concatStringTagsToArray(tagInput, tagArray);
      onTagsUpdated(updatedTags || []);
      setTagInput("");
    }
  };

  const handleTagDeletion = (event: FormEvent, tag: string) => {
    event.preventDefault();
    if (tagArray.includes(tag)) {
      const updatedTags = tagArray.filter((t) => t !== tag);
      onTagsUpdated(updatedTags);
    }
  };

  return (
    <>
      <Form.Group className={formClass}>
        <Form.Label>Tags</Form.Label>
        <Form.Text className="text-muted">
          Enter the tags associated with this organisation
        </Form.Text>
        <div className="flex gap-2 items-center">
          <Form.Control
            placeholder="Comma, seperated, tags"
            size="lg"
            name="organisationTags"
            type="text"
            value={tagInput}
            onChange={handleChangeTagInput}
            disabled={disabled}
          />
          <Button
            className="min-w-[60px]"
            onClick={handleAddTags}
            variant="primary-3"
            disabled={disabled}
          >
            Add
          </Button>
        </div>
        <div>
          <span className="my-1 spanTagItem">
            <TagComponentMapper
              disabled={disabled}
              tags={tagArray}
              onDelete={handleTagDeletion}
              showCloseIcon={!disabled}
            />
          </span>
        </div>
      </Form.Group>
    </>
  );
};

export default TagInput;
